var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('categories')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"generic-wizard-heading"},[_vm._v("Select A Category")]),_vm._v(" "),_c('p',{staticClass:"generic-wizard-subheading"},[_vm._v("Don’t worry you are just a few clicks away.")])])])
}]

export { render, staticRenderFns }